import React, { useState, useEffect } from 'react';
import api from './http';

export default function GlobalLoginModal({
    role = 'proctor',
    title = 'Session Expired',
    subtitle = 'Please log back in to continue working without losing your progress.',
    onLoginSuccess
}) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Lock background scroll while open. Capture the previous value so we
    // restore it (rather than always falling back to 'auto') on unmount.
    useEffect(() => {
        const previous = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = previous; };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const endpoint = role === 'admin' ? '/admin/login' : '/api/proctor/login';
            const res = await api.post(endpoint, { username, password });

            if (res.data.success) {
                if (onLoginSuccess) onLoginSuccess(res.data.user);
            } else {
                setError(res.data.message || 'Invalid credentials');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Invalid credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="reauth-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="reauth-modal-title">
            <div className="reauth-modal">
                <div className="reauth-modal-header">
                    <h2 id="reauth-modal-title">{title}</h2>
                    {subtitle && <p>{subtitle}</p>}
                </div>

                <form onSubmit={handleSubmit} className="reauth-modal-form">
                    <div className="login-field">
                        <label htmlFor="reauth-username">Username</label>
                        <input
                            id="reauth-username"
                            type="text"
                            placeholder="Enter your username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            autoComplete="username"
                            autoCapitalize="none"
                            required
                            autoFocus
                        />
                    </div>
                    <div className="login-field">
                        <label htmlFor="reauth-password">Password</label>
                        <input
                            id="reauth-password"
                            type="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            required
                        />
                    </div>

                    {error && <div className="login-error">{error}</div>}

                    <button type="submit" className="login-submit" disabled={loading}>
                        {loading ? 'Signing in…' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
}
